import classNames from "classnames"
import { useEffect, useMemo, useState } from "react"

// utils
import { extractLangCode } from "../../utils/general_utils"

// styles
import * as globalStyles from "../../theme/global.module.scss"
import * as styles from "./RegionSelector.module.scss"

export const RegionSelector = () => {
  const currentLangCode = extractLangCode()

  const [value, setValue] = useState("")

  const baseHostName = useMemo(() => {
    return process.env.GATSBY_BASE_HOST_NAME
  }, [])
  const isEvbqa = useMemo(() => {
    return baseHostName?.includes("evbqa")
  }, [baseHostName])

  const locales = useMemo(
    () =>
      [
        {
          langCode: "es-ar",
          label: "Argentina",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/es-ar/`
            : `https://www.${baseHostName}.com.ar/help/es-ar/`
        },
        {
          langCode: "es-cl",
          label: "Chile",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/es-cl/`
            : `https://www.${baseHostName}.cl/help/es-cl/`
        },
        {
          langCode: "es-co",
          label: "Colombia",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/es-co/`
            : `https://www.${baseHostName}.co/help/es-co/`
        },
        {
          langCode: "es",
          label: "España",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/es/`
            : `https://www.${baseHostName}.es/help/es/`
        },
        {
          langCode: "es-mx",
          label: "México",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/es-mx/`
            : `https://www.${baseHostName}.com.mx/help/es-mx/`
        },
        {
          langCode: "es-pe",
          label: "Perú",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/es-pe/`
            : `https://www.${baseHostName}.com.pe/help/es-pe/`
        },
        {
          langCode: "fr",
          label: "France",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/fr/`
            : `https://www.${baseHostName}.fr/help/fr/`
        },
        {
          langCode: "de",
          label: "Deutschland",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/de/`
            : `https://www.${baseHostName}.de/help/de/`
        },
        {
          langCode: "it",
          label: "Italia",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/it/`
            : `https://www.${baseHostName}.it/help/it/`
        },
        {
          langCode: "nl-nl",
          label: "Nederland",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/nl-nl/`
            : `https://www.${baseHostName}.nl/help/nl-nl/`
        },
        {
          langCode: "pt-pt",
          label: "Portugal",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/pt-pt/`
            : `https://www.${baseHostName}.pt/help/pt-pt/`
        },
        {
          langCode: "fr-ch",
          label: "Suisse",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/fr-ch/`
            : `https://www.${baseHostName}.ch/help/fr-ch/`
        },
        {
          langCode: "de-ch",
          label: "Schweiz",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/de-ch/`
            : `https://www.${baseHostName}.ch/help/de-ch/`
        },
        {
          langCode: "en-sg",
          label: "Singapore",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/en-sg/`
            : `https://www.${baseHostName}.sg/help/en-sg/`
        },
        {
          langCode: "en-hk",
          label: "Hong Kong",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/en-hk/`
            : `https://www.${baseHostName}.hk/help/en-hk/`
        },
        {
          langCode: "pt-br",
          label: "Brasil",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/pt-br/`
            : `https://www.${baseHostName}.com.br/help/pt-br/`
        },
        {
          langCode: "en-au",
          label: "Australia",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/en-au/`
            : `https://www.${baseHostName}.com.au/help/en-au/`
        },
        {
          langCode: "en-ca",
          label: "Canada (EN)",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/en-ca/`
            : `https://www.${baseHostName}.ca/help/en-ca/`
        },
        {
          langCode: "fr-ca",
          label: "Canada (FR)",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/fr-ca/`
            : `https://www.${baseHostName}.ca/help/fr-ca/`
        },
        {
          langCode: "en-gb",
          label: "United Kingdom",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/en-gb/`
            : `https://www.${baseHostName}.co.uk/help/en-gb/`
        },
        {
          langCode: "en-ie",
          label: "Ireland",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/en-ie/`
            : `https://www.${baseHostName}.ie/help/en-ie/`
        },
        {
          langCode: "fi",
          label: "Finland",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/fi/`
            : `https://www.${baseHostName}.fi/help/fi/`
        },
        {
          langCode: "da",
          label: "Denmark",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/da/`
            : `https://www.${baseHostName}.dk/help/da/`
        },
        {
          langCode: "en-nz",
          label: "New Zealand",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/en-nz/`
            : `https://www.${baseHostName}.co.nz/help/en-nz/`
        },
        {
          langCode: "sv",
          label: "Sweden",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/sv/`
            : `https://www.${baseHostName}.se/help/sv/`
        },
        {
          langCode: "en-us",
          label: "United States",
          value: isEvbqa
            ? `https://www.${baseHostName}.com/help/en-us/`
            : `https://www.${baseHostName}.com/help/en-us/`
        }
      ].sort((a, b) => {
        const labelA = a.label.toLowerCase()
        const labelB = b.label.toLowerCase()

        if (labelA < labelB) {
          return -1
        }
        if (labelA > labelB) {
          return 1
        }
        return 0
      }),
    []
  )

  useEffect(() => {
    if (typeof window !== "undefined") {
      if (!value && currentLangCode?.length > 0 && locales?.length > 0) {
        const valueFromLangCode = locales?.find(
          (x) => x?.langCode?.toLowerCase() === currentLangCode?.toLowerCase()
        )?.value

        if (valueFromLangCode) {
          setValue(valueFromLangCode)
        }
      }
    }
  }, [currentLangCode, locales])

  const onChange: React.ChangeEventHandler<HTMLSelectElement> = (event) => {
    const value = event?.target?.value

    if (value) {
      if (typeof window !== "undefined") {
        try {
          // Get current URL
          const currentURL = window?.location?.href
          // Get everything after the lang code
          const startIndex =
            currentURL.indexOf(`/${currentLangCode}`) +
            currentLangCode.length +
            2
          const urlLocation = currentURL.slice(startIndex)
          // Create a new URL object with the input string. This serves to validate the URL and throw an exception if it's not valid
          const url = new URL(value + urlLocation)
          if (isEvbqa) {
            console.log(
              "🚀 ~ file: RegionSelector.tsx:74 ~ RegionSelector ~ url:",
              { url, value }
            )
          }
          // If no exception is thrown, the URL is valid
          window.location.href = value + urlLocation
        } catch (error) {
          // If an exception is thrown, the URL is not valid
          return false
        }
      }

      setValue(value)
    }
  }

  return (
    <div className={globalStyles.edsFieldStyled__selectWrapper}>
      <select
        className={classNames(
          globalStyles.edsFieldStyled__input,
          styles.selectContainer
        )}
        aria-labelledby="global-footer-region-select-label"
        role="listbox"
        name="global-footer-region-select"
        value={value}
        onChange={onChange}
      >
        {locales?.length > 0
          ? locales.map((locale) => {
              if (locale?.label && locale?.value) {
                return (
                  <option key={locale?.value} value={locale?.value}>
                    {locale?.label}
                  </option>
                )
              }
            })
          : null}
      </select>
    </div>
  )
}
